import { Button, Heading, Text } from "@radix-ui/themes";
import i18next from "i18next";
import { FC } from "react";
import CookieConsent from "react-cookie-consent";
import { Link } from "react-router-dom";

interface ConsentProps {
  layout?: "default" | "small";
}

const Consent: FC<ConsentProps> = (layout): JSX.Element => {
  const isSmall =
    window.location.pathname === "/" ||
    window.location.pathname === "/landing" ||
    window.location.pathname === "/login" ||
    window.location.pathname === "/enter-username" ||
    window.location.pathname === "/forgot-password" ||
    window.location.pathname === "/verify-email" ||
    window.location.pathname === "/signup" ||
    window.location.pathname === "/password-reset" ||
    layout.layout === "small";

  const layoutClass = layout
    ? `CookieConsent__layout CookieConsent__layout--${layout.layout}`
    : "";
  const actionClass = layout ? `CookieConsent__actions--${layout.layout}` : "";
  const btnClass = layout ? `CookieConsent__btn--${layout.layout}` : "";
  const bodyClass = layout ? `CookieConsent__body--${layout.layout}` : "";

  return (
    <CookieConsent
      location="none"
      buttonText={i18next.t("cookies.button.accept")}
      expires={90}
      enableDeclineButton
      declineButtonText={i18next.t("cookies.button.decline")}
      disableStyles={true}
      containerClasses={"CookieConsent " + layoutClass}
      contentClasses={"CookieConsent__body " + bodyClass}
      overlayClasses="CookieConsent__overlay"
      buttonWrapperClasses={"rt-Flex rt-r-fw-wrap rt-r-gap-3 " + actionClass}
      declineButtonClasses={
        "rt-reset rt-BaseButton rt-r-size-2 rt-variant-solid rt-Button " +
        btnClass
      }
      buttonClasses={
        "rt-reset rt-BaseButton rt-r-size-2 rt-variant-solid rt-Button " +
        btnClass
      }
      overlay={!isSmall}
      // debug={true}
    >
      <Heading as="h2" size="3">
        {i18next.t("cookies.headline")}
      </Heading>
      <Text as="p" size="2">
        {i18next.t("cookies.description")}
        {!isSmall && (
          <ul>
            <li>{i18next.t("cookies.essential")}</li>
            <li>{i18next.t("cookies.optional")}</li>
          </ul>
        )}{" "}
        {i18next.t("cookies.more")}{" "}
        <Link to="/privacy-policy">{i18next.t("cookies.link")}</Link>
      </Text>
    </CookieConsent>
  );
};

export default Consent;
